/**
 * Start of the current UTC day as unix seconds. Rounded to the day (not the
 * second) so every list request in a day shares one filter value and the
 * Typesense query cache stays effective.
 */
export function startOfTodayUnix(now: Date = new Date()): number {
  return Math.floor(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()) / 1000,
  );
}
